import { useMemo } from 'react';

import { Box } from '@chakra-ui/react';
import { getUserL2Access } from 'Deer/helpers/getUserAccess';

import { ProfileHeaderCard } from '../../../components/ProfilePage/components/ProfileHeaderCard';
import { FeedbackOverview } from '../MyData/Overview/cards/FeedbackOverview/FeedbackOverview';
import { GoalsOverview } from '../MyData/Overview/cards/GoalsOverview/GoalsOverview';
import OneOnOneOverview from '../MyData/Overview/cards/OneOnOneOverview/OneOnOneOverview';
import { ReviewsOverview } from '../MyData/Overview/cards/ReviewsOverview/ReviewsOverview';
import { ProfileContext } from './hooks/ProfileContext';

const ProfileOverview = ({ employee, isVisitingOwnProfile }) => {
  const modules = [
    { check: () => getUserL2Access().hasReviewAccess, component: <ReviewsOverview /> },
    { check: () => getUserL2Access().hasGoalAccess, component: <GoalsOverview /> },
    {
      check: () => getUserL2Access().hasFeedbackAccess,
      component: <FeedbackOverview />,
    },
    {
      check: () => getUserL2Access().hasOneOnOneAccess,
      component: <OneOnOneOverview />,
    },
  ];

  const employeeContext = useMemo(() => ({ ...employee, isVisitingOwnProfile }), [employee, isVisitingOwnProfile]);
  return (
    <div>
      <ProfileContext.Provider value={employeeContext}>
        <ProfileHeaderCard employee={employee} />
        <Box mb={3} />
        {modules?.map(
          ({ check, component }, index) =>
            check() && (
              // eslint-disable-next-line react/no-array-index-key
              <Box mb={3} key={index}>
                {component}
              </Box>
            )
        )}
      </ProfileContext.Provider>
    </div>
  );
};
export { ProfileOverview };
